'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_i18n_maybeFormatMessage = require('./maybeFormatMessage.js');

function maybeFormatPrefixedMessage(intl, keyPrefix) {
  var formatMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : utils_i18n_maybeFormatMessage['default'];
  return function (keySuffix) {
    return formatMessage(intl, keyPrefix, keySuffix);
  };
}

exports.default = maybeFormatPrefixedMessage;
//# sourceMappingURL=maybeFormatPrefixedMessage.js.map
